/** Values that can be serialised into a query-string parameter. */
export type QueryParamValue = string | number | boolean | null | undefined;

/**
 * Build a URL with an encoded query string from a params object. Params whose
 * value is `undefined` or `null` are omitted. When no params survive filtering
 * the empty string is returned (matching the original util.url.build behaviour).
 * @param url   Base URL without a query string.
 * @param params Key/value pairs to encode as the query string.
 * @return The URL with `?query` appended, or `''` when there are no params.
 */
export const build = (
    url: string,
    params: Record<string, QueryParamValue> = {},
): string => {
    const searchString = Object.entries(params)
        .filter(([, val]) => val !== undefined && val !== null)
        .map(([key, val]) => `${key}=${encodeURIComponent(val as string | number | boolean)}`)
        .join('&');

    if (searchString.length) {
        return `${url}?${searchString}`;
    }

    return searchString;
};
